<template>
  <div class="list--view">
      <div class="single--list-view single--list-view-employees">
        <vs-select
            class="selectExample"
            v-model="selectKpiApproved"
            @input="kpiApproved"
        >
        <vs-select-item
              :is-selected="item.isSelected"
              :key="index"
              :value="item.value"
              :text="item.label"
              v-for="(item,index) in optionsKpis" />
        </vs-select>
      </div>
    </div>
</template>

<script>
export default {

    methods: {
        getSelectedKpiApprovedMethod(){

          let approvedAtValue = 'all';
          if (location.search.indexOf("approved_at") >= 0 ){
            approvedAtValue = (/approved_at=([^&]+)/.exec(location.href)[1] === "1") ? 'approved_at' : 'not_approved';
          }

          return approvedAtValue;
        },
        kpiApproved(selectedOption, id) {
            if (selectedOption === 'all') {
                location.href = app.__vue__.removeParam("approved_at");
            } else if (selectedOption == "approved_at") {
                location.href = app.__vue__.addParam("approved_at", "1");
            }if (selectedOption == "not_approved") {
                location.href = app.__vue__.addParam("approved_at", "0");
            }
        },
    },
    data () {
      return {
        selectKpiApproved: this.getSelectedKpiApprovedMethod(),
        optionsKpis:[
          {value: 'all', label: 'Tutti', isSelected: true  },
          {value: 'approved_at', label: 'Approvati',isSelected: false  },
          {value: 'not_approved', label: 'Non Approvati', isSelected: false },
        ],

      }
    },
    mounted(){

    }
    
}
</script>
